import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { Link, useParams, useNavigate } from "react-router-dom";
import AddNewSubAssembly from "../components/addSubAssemblyModal";
import EditSubAssembly from "../components/editSubAssemblyModal";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_typeMaster = () => {
useAuthRedirect();
    const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [formData, setFormData] = useState({ sa: ""});
  const [subData, setSubData] = useState([]);

   const canView  = hasPermission("Vehicle Type Maintenance", "view");
      const canEntry = hasPermission("Vehicle Type Maintenance", "entry");
      const canEdit  = hasPermission("Vehicle Type Maintenance", "edit");
      const canDel   = hasPermission("Vehicle Type Maintenance", "del");
 

useEffect(() => {
  const fetchSubData = async () => {
    try {
      const res = await axios.get("https://rfs2.infraconsoft.net.in/api/get_vehicle_maintenance");
      setSubData(res.data); // assuming res.data is an array of { fld_subid, ... }
    } catch (err) {
      console.error("Failed to load sub-records", err);
    }
  };

  fetchSubData();
}, []);

const subRecordExists = (id) => {
    return subData.some(sub => sub.fld_subid === id);
  };
  


  useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_subassembly_api/${id}`);
      setData(response.data.subassemblys);
      setFilteredData(response.data.subassemblys);
    } catch (error) {
      console.error("Error fetching subassemblys:", error);
    } finally {
      setLoading(false);
    }
  };
  fetchData();
}, []);

const handleCheckboxChange = (id) => {
    const numericId = Number(id); // ensure numeric
    setSelectedIds((prev) =>
      prev.includes(numericId)
        ? prev.filter((i) => i !== numericId)
        : [...prev, numericId]
    );
  };
    

  const handleBulkDelete = () => {
    if (selectedIds.length === 0) {
      Swal.fire("Warning", "No items selected for deletion.", "warning");
      return;
    }
  
    console.log("Selected IDs to delete:", selectedIds);
  
    Swal.fire({
      title: `Delete ${selectedIds.length} item(s)?`,
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete them!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
           Swal.fire({
                              title: "Submitting...",
                              text: "Please wait while we process your request.",
                              allowOutsideClick: false,
                              didOpen: () => {
                                  Swal.showLoading();
                              },
                          });
          const deleteRequests = selectedIds.map((id) => {
            console.log(`Sending DELETE request for ID: ${id}`);
            return axios.delete(`https://rfs2.infraconsoft.net.in/api/sa_delete/${id}`);
          });
  
          await Promise.all(deleteRequests);
  
          // Remove from UI
          const updatedData = data.filter((item) => !selectedIds.includes(item.fld_subid));
          setData(updatedData);
          setFilteredData(updatedData);
          setSelectedIds([]);
  
          Swal.fire("Deleted!", "Selected records have been deleted.", "success");
          window.location.reload();
        } catch (error) {
          console.error("Bulk delete error:", error);
          if (error.response) {
            console.error("Server response:", error.response.data);
          }
          Swal.fire("Error", "Failed to delete selected records.", "error");
        }
      }
    });
  };

  const openAddModal = () => {
    setIsAddModalOpen(true);
  };

  const closeAddModal = () => {
    setIsAddModalOpen(false);
  };

   const [isEditModalOpen, setIsEditModalOpen] = useState(false);
      const [editFormData, setEditFormData] = useState({ sa: "", subId: "" });
      
      const openEditModal = (item) => {
          setEditFormData({  sa: item.fld_subassembly, subId: item.fld_subid });
          setIsEditModalOpen(true);
      };
      
      const closeEditModal = () => {
          setIsEditModalOpen(false);
      };
    
  


  
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.fld_subassembly || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };
  


  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                                        <h2 className="add-txt">Add Sub Assembly</h2>
                                        <Link to={`/vehicle_type_maintenance_listing`}><p className="back-button"><i className="fa-solid fa-backward"></i> Back</p></Link>
                                        </div>
          <Time />
        </section>


        {/* Add New Button */}
        {canEntry && (
       <div className="add-new-container">
        <button className="add-new-btn" onClick={() => openAddModal()}>
              <i className="fa-solid fa-plus" ></i> Add New
            </button>
        </div>
        )}

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by Vehicle Type"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Vehicle Type</th>
                {canEdit && (
                <th>Edit</th>
                )}
                {canDel && (
                <th>
      <button onClick={handleBulkDelete} className="btn btn-danger btn-sm ms-2">
        Delete
      </button>
    </th>
                )}
              </tr>
            </thead>
            <tbody>
  {loading ? (
    <tr>
      <td colSpan="6" className="loading-text">Loading data, please wait...</td>
    </tr>
  ) : currentData.length > 0 ? (
    currentData.map((item, index) => (
      <tr key={index}>
        <td>{indexOfFirstItem + index + 1}</td>
        <td>{item.fld_subassembly}</td>
        {canEdit && (
        <td>
          <Link onClick={() => openEditModal(item)} style={{color : "#030d68", fontWeight: "bold", cursor: "pointer"}}>
            Edit
          </Link>
        </td>
        )}

        {canDel && (
        <td>
           <input
           type="checkbox"
           checked={selectedIds.includes(Number(item.fld_subid))}
           onChange={() => handleCheckboxChange(item.fld_subid)}
         />
        </td>
        )}
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6">No Data Available</td>
    </tr>
  )}
</tbody>

          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
      <AddNewSubAssembly isAddOpen={isAddModalOpen} onAddClose={closeAddModal} formData={formData}  setFormData={setFormData} id={id} />
      <EditSubAssembly
    isOpen={isEditModalOpen}
    onClose={closeEditModal}
    editFormData={editFormData}
    setEditFormData={setEditFormData}
    id={id}
/>
    </div>
  );
};


export default Vehicle_typeMaster;
